module.exports = __webpack_public_path__ + "static/media/client-background.956d16b5.jpg";